import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Heart } from 'react-feather';
import { Col, Card, CardBody, Button } from 'reactstrap';
import { Image, VariantPrice } from '@bottomless/common/components';

const ProductComponent = ({ product, history, pricingRule, isFirstBag, onChooseProduct, hasCustomStyles, me }) => {
  const likesProportion = useMemo(() => {
    const likes = product.likes || 0;
    const dislikes = product.dislikes || 0;

    if (!likes && !dislikes) {
      return null;
    }

    return likes + dislikes;
  }, [product.likes, product.dislikes]);

  const navigateToProductPage = () => {
    history.push(`/products/${product.slug}?vendor=true`);
  };

  return (
    <Col xs="12" md="6" lg="4" className="mb-3">
      <div className="h-100" onClick={navigateToProductPage}>
        <Card className="h-100" body>
          <div className="d-flex align-items-center">
            <div className="pr-2">
              <Image width="120" src={product.small_image_src} alt={product.name} />
            </div>
            <div className="w-100">
              <h6 className="product-name">{product.name}</h6>
              <div className="small">
                {(product.roast || product.origin) && (
                  <>
                    {product.roast && <span>{product.roast.name}</span>}
                    {product.origin && <span> {product.origin.name}</span>}
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center h-100">
            <CardBody className="d-flex flex-column h-100 justify-content-between pl-0">
              <div className="variants-container">
                {product.variants
                  .filter(v => v.available)
                  .sort((a, b) => (a.size > b.size ? 1 : -1))
                  .map((variant, i) => (
                    <div key={i} className="d-flex justify-content-between variant-item py-1">
                      <span>{variant.size}oz</span>
                      <span>
                        <VariantPrice
                          user={me}
                          variant={variant}
                          pricingRule={pricingRule}
                          isFirstBag={isFirstBag}
                          size={variant.size}
                        />
                      </span>
                    </div>
                  ))}
              </div>
              {hasCustomStyles && (
                <Button
                  color="primary"
                  outline
                  size="sm"
                  onClick={e => onChooseProduct(e, product, { variant: product.variants[0]._id })}
                  className="mt-3"
                >
                  Buy Product
                </Button>
              )}
            </CardBody>
          </div>
          {!product.likes ? null : (
            <div className="d-flex justify-content-center">
              <span className="likes">
                <span className="text-nowrap">
                  <Heart size="18" fill="#ec2d2d" color="#ec2d2d" className="mr-1" />
                  {product.likes}
                  {likesProportion !== null && <span className="ml-1">of {likesProportion} reviews</span>}
                </span>
              </span>
            </div>
          )}
        </Card>
      </div>
    </Col>
  );
};

ProductComponent.propTypes = {
  product: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  pricingRule: PropTypes.object,
  isFirstBag: PropTypes.bool.isRequired,
  onChooseProduct: PropTypes.func.isRequired,
  hasCustomStyles: PropTypes.bool.isRequired,
  me: PropTypes.any,
};

export const Product = memo(ProductComponent);
